module.exports = __webpack_public_path__ + "img/toyota-specials.6f00636b.png";